module.exports = __webpack_public_path__ + "assets/img/down_2.476b430e.png";